import { Controller } from "@hotwired/stimulus";

// Loading indicator controller for Turbo Frame requests
export default class extends Controller {
  static targets = ["overlay"];

  connect() {
    // Show loading when Turbo Frame starts loading
    this.element.addEventListener(
      "turbo:before-frame-render",
      this.showLoading.bind(this)
    );
    this.element.addEventListener(
      "turbo:frame-render",
      this.hideLoading.bind(this)
    );
    this.element.addEventListener(
      "turbo:frame-load",
      this.hideLoading.bind(this)
    );
  }

  disconnect() {
    this.element.removeEventListener(
      "turbo:before-frame-render",
      this.showLoading.bind(this)
    );
    this.element.removeEventListener(
      "turbo:frame-render",
      this.hideLoading.bind(this)
    );
    this.element.removeEventListener(
      "turbo:frame-load",
      this.hideLoading.bind(this)
    );
  }

  showLoading() {
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove("hidden");
    }
  }

  hideLoading() {
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.add("hidden");
    }
  }
}
